import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import arrowIconBottom from "./../../../../../assets/_ArrowIconBottom_.svg";
import closeIconModal from "./../../../../../assets/_CloseIconModal_.svg";
import styles from "./styles.module.scss";
import { stringAvatar } from "../../../../../utils/avatar";
import { Modal } from "@mui/material";
import { ButtonDeleted } from "../../../../../components/ButtonDeleted";
import { useConfirm } from "../../../../../hooks/useConfirm";
import React from "react";
import { getAllUsersByGroupId, removeUserFromGroup } from "../../../../../services/api/user/UserService"
import { IUserItem } from "../../../../../@types/user.type";
import { Button as ButtonCustom } from "./../../../../../components/Button";
import addCircleImage from "./../../../../../assets/_AddCircleIcon_.svg";
import { CreateUserModal } from "../ModalCreateUser";
import { toast } from "react-toastify";

interface ListData {
  id: string;
  name: string;
}

interface DefaultListProps {
    groupId: string;
}

export const DefaultList: React.FC<DefaultListProps> = ({
    groupId
  }) => {
  const [listing, setListing] = useState<ListData[]>([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [isModalCreateUserOpen, setModalCreateUserOpen] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleCloseModalCreateUser = () => setModalCreateUserOpen(false);

  const displayedList = showAll ? listing : listing.slice(0, 3);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const handleOpenModalConfirm = () => setOpenModalConfirm(true);
  const handleCloseModalConfirm = () => setOpenModalConfirm(false);
  const [reload, setReload] = useState(true);

  useEffect(() => {
    const fetchList = async () => {
      try {

        const response = await getAllUsersByGroupId(groupId);
        
        if (response.statusCode !== 200) {
          throw new Error(
            response.message || "Erro ao buscar os dados dos grupos"
          );
        }

        const formattedList = response.result.map((user: IUserItem) => ({
          id: user.id,
          name: `${user.firstname} ${user.lastname}`,
        }));

        setListing(formattedList);
        if (formattedList.length === 0) {
          handleCloseModal();
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          console.log(error.message);
        } else {
          console.log("Ocorreu um erro inesperado");
        }
      } finally {
        setLoading(false);
      }
    };
    
    fetchList();
  }, [isModalCreateUserOpen, reload]);



  const { showConfirm, Confirm } = useConfirm(
    "Tem certeza que deseja excluir o membro?", 
    openModalConfirm,
    handleCloseModalConfirm
  );

  const handleDelete = async (userId: string) => {
    handleOpenModalConfirm();
    try {
      const isConfirm = await showConfirm();
      if (isConfirm) {
        await removeUserFromGroup(userId, groupId);
        setReload((prev) => !prev);
        toast.success("Membro excluído com sucesso!");
        console.log(reload)
      }
    } catch (error) {
      console.error("Erro ao deletar:", error);
    }
  };

  return (
    <>
      <div className={styles.titleAndBtnCreate}>
          <ButtonCustom
            iconUrl={addCircleImage}
            onClick={() => setModalCreateUserOpen(true)}
            content="Novo Membro"
            className={styles.button}
          />
      </div>
      <div>
        <h1 className={styles.title}>Lista de Membros</h1>
      <List className={styles.listContainer}>
        {displayedList.length === 0 ||
        displayedList.every((user) => user.id === undefined) ? (
          <ListItem alignItems="center" className={styles.listItem}>
            <ListItemText
              className={styles.listItemText}
              primary={
                <span className={styles.primaryText}>
                  Não existem membros nesse grupo
                </span>
              }
              secondary={
                <span className={styles.secondaryText}>
                    É possível adicionar membros no botão Novo Membro
                </span>
              }
              style={{ textAlign: "center" }}
            />
          </ListItem>
        ) : (
          displayedList.map((user, index) => (
            <React.Fragment key={user.id}>
              <ListItem alignItems="center" className={styles.listItem}>
                <Avatar className={styles.avatar} {...stringAvatar(user.name)} />
                <ListItemText
                  className={styles.listItemText}
                  primary={
                    <span className={styles.primaryText}>{user.name}</span>
                  }
                />
                <div>
                  <ButtonDeleted
                    handleDeleteItem={() => user.id && handleDelete(user.id)}
                  />
                </div>
              </ListItem>
              {listing.length > 3 ? (
                  <Divider variant="middle" component="li" className={styles.divider} />
                ) : (
                  index < displayedList.length - 1 && (
                    <Divider variant="middle" component="li" className={styles.divider} />
                  )
              )}
            </React.Fragment>
          ))
        )}

        {displayedList.length !== 0 && listing.length > 3 &&
          displayedList.every((user) => user.id !== undefined) && (
            // Exibe o botão "Ver Mais" apenas se houver lista
            <ListItem
              style={{ justifyContent: "center" }}
              className={styles.listItemSeeMore}
            >
              <Button
                onClick={handleOpenModal}
                variant="text"
                color="primary"
                sx={{ textTransform: "none", padding: "10px 8px" }}
                className={styles.buttonSeeMore}
              >
                <div>Ver Mais</div>
                {arrowIconBottom && (
                  <img src={arrowIconBottom} style={{ marginLeft: "8px" }} />
                )}
              </Button>
            </ListItem>
          )}
      </List>
      </div>

      <Modal open={openModal} onClose={handleCloseModal}>
        <div className={styles.modal}>
          <div className={styles.header}>
            <h3>Membros</h3>
            <Button onClick={handleCloseModal} className={styles.iconButton}>
              {closeIconModal && <img src={closeIconModal} />}
            </Button>
          </div>
          <List className={styles.listContainerModal}>
            {listing.map((user) => (
              <React.Fragment key={user.id}>
                <ListItem alignItems="center" className={styles.listItemModal}>
                  <Avatar className={styles.avatar} {...stringAvatar(user.name)} />
                  <ListItemText
                    className={styles.listItemText}
                    primary={
                      <span className={styles.primaryText}>{user.name}</span>
                    }
                  />
                  <ButtonDeleted
                    handleDeleteItem={() => user.id && handleDelete(user.id)}
                  />
                </ListItem>
                <Divider
                  variant="middle"
                  component="li"
                  className={styles.divider}
                />
              </React.Fragment>
            ))}
          </List>
        </div>
      </Modal>
      <CreateUserModal 
        open={isModalCreateUserOpen} onClose={handleCloseModalCreateUser} groupId={groupId} reload = {reload}
      />

      {Confirm}
    </>
  );
}
